__turbopack_context__.v({
  "chevron": "lXnxNq_chevron",
  "panel": "lXnxNq_panel",
  "trigger": "lXnxNq_trigger",
});
